import { baseAPI } from "../baseApi";

export const roadCategorySegmentsApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение всех типов покрытий для базы с их протяженностью
        fetchCategoryGroupsDict: builder.query<any, any>({
            query: () => ({
                url: `Objects/CategoryGroups`
            })
        }),
    })
})

export const {
    useFetchCategoryGroupsDictQuery,
} = roadCategorySegmentsApiSlice